/* global axios */
import ApiClient from './ApiClient';

// Aba Template da caixa (so user id 1; guard no backend InboxPolicy).
// Lista/cria templates direto na Meta com as credenciais da propria caixa.
class InboxTemplatesAPI extends ApiClient {
  constructor() {
    super('inboxes', { accountScoped: true });
  }

  listTemplates(inboxId) {
    return axios.get(`${this.url}/${inboxId}/templates`);
  }

  createTemplate(inboxId, template) {
    return axios.post(`${this.url}/${inboxId}/create_template`, { template });
  }

  uploadTemplateMedia(inboxId, file) {
    const formData = new FormData();
    formData.append('file', file);
    return axios.post(`${this.url}/${inboxId}/upload_template_media`, formData);
  }
}

export default new InboxTemplatesAPI();
